import { render, staticRenderFns } from "./edit-pharmacy.vue?vue&type=template&id=522f3327&"
import script from "./edit-pharmacy.vue?vue&type=script&lang=js&"
export * from "./edit-pharmacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports